import Home from "pages/Home";
import SharedLayout from "utils/SharedLayout";
import { HomeRedirect } from "./HomeRedirect";
import { useTranslation } from "react-i18next";
import SubAdmin from "pages/sub_admin/SubAdmin";
import SubAdd from "pages/sub_admin/SubAdd";
import SubEdit from "pages/sub_admin/SubEdit";
import StaticContent from "pages/static_Contents/StaticContent";
import AddStaticContent from "pages/static_Contents/AddStaticContent";
import EditStaticContent from "pages/static_Contents/EditStaticContent";
import StaticContentView from "pages/static_Contents/StaticContentView";
import CountryManager from "pages/country_manager/CountryManager";
import StateManager from "pages/state_manager/StateManager";
import CityManager from "pages/city_manager/CityManager";
import CategoryManager from "pages/category_manager/CategoryManager";
import RegisteredCompanies from "pages/reports/RegisteredCompanies";
import SubscriptionStatistics from "pages/reports/SubscriptionStatistics";
import SupportManager from "pages/support_manager/SupportManager";
import NotificationManager from "pages/notification_manager/NotificationManager";
import AddNotification from "pages/notification_manager/AddNotification";
import EditNotification from "pages/notification_manager/EditNotification";
import SubscriptionManager from "pages/subscription_manager/SubscriptionManager";
import BannerManager from "pages/banner_manager/BannerManager";
import Subcategory from "pages/category_manager/subcategory/Subcategory";
import EarningManager from "pages/earning_manager/EarningManager";
import CompanyManager from "pages/company_manager/CompanyManager";
import EditCompanyManager from "pages/company_manager/EditCompany";
import FormsManager from "pages/forms_manager/FormsManager";
import JobsManager from "pages/jobs_manager/JobsManager";
import CompanyOnboarding from "pages/company_onboarding/CompanyOnboarding";
import ProfileTabs from "pages/profile/ProfileTabs";
import ChangePassword from "pages/auth/ChangePassword";
import Sidebar from "components/sidebar/Sidebar";
import BannerAdd from "pages/banner_manager/BannerAdd";
import BannerEdit from "pages/banner_manager/BannerEdit";
import BellNotifications from "pages/notification_manager/BellNotifications";
import FAQ from "pages/faqs/FAQ";
import Settings from "pages/settings/Settings";
import AuthorizationRoute from "utils/AuthorizationRoute";
import HiringView from "pages/forms_manager/hiring/HiringView";
import OnboardingView from "pages/forms_manager/onboarding/OnboardingView";
import BlogManagement from "pages/blog/BlogManagement";
import BlogAdd from "pages/blog/AddBlog";
import BlogEdit from "pages/blog/BlogEdit";
import BlogView from "pages/blog/BlogView";
import VideoManagement from "pages/video_manager/VideoManagement";
import AddVideo from "pages/video_manager/AddVideo";
import VideoEdit from "pages/video_manager/VideoEdit";
import VideoView from "pages/video_manager/VideoView";
import AuditLogs from "pages/auditLogs/AuditLogs";
import BackgroundCheckPricing from "pages/backgroundCheckPricing/BackgroundCheckPricing";
import BusinessIntelligence from "pages/businessIntelligence/BusinessIntelligence";
import GeoAccess from "pages/geo_access/GeoAccess";
import PartnerInquiryList from "pages/partner_inquiries/PartnerInquiryList";
import PartnerInquiryView from "pages/partner_inquiries/PartnerInquiryView";
import PayrollAdminDashboard from "pages/admin-payroll/PayrollAdminDashboard";

const UseChange = ({ data }) => {
  let { t } = useTranslation();
  return t(data);
};

const AdminRoutes = {
  // All common routes
  path: "/",
  element: <SharedLayout type={<Sidebar />} />,
  children: [
    {
      path: "/",
      element: <AuthorizationRoute></AuthorizationRoute>,
      name: <UseChange data="NAV_DASHBOARD" />,
    },
    {
      path: "/dashboard",
      element: <Home />,
      name: <>{<UseChange data="NAV_DASHBOARD" />}</>,
    },
    {
      path: "/sub-admin-manager",
      element: (
        <AuthorizationRoute>
          <SubAdmin />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="SUB_ADMIN_MANAGERS" />}</>,
    },
    {
      path: "/business-intelligence",
      element: (
        <AuthorizationRoute>
          <BusinessIntelligence />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_BI_DASHBOARD" />}</>,
    },
    {
      path: "/sub-admin-manager/add",
      element: (
        <AuthorizationRoute>
          <SubAdd />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="SUB_ADMIN_MANAGERS" />}</>,
    },
    {
      path: "/sub-admin-manager/edit",
      element: (
        <AuthorizationRoute>
          <SubEdit />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="SUB_ADMIN_MANAGERS" />}</>,
    },
    {
      path: "/static-page-management",
      element: (
        <AuthorizationRoute>
          <StaticContent />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_STATIC_CONTENTS" />}</>,
    },
    {
      path: "/static-page-management/add",
      element: (
        <AuthorizationRoute>
          <AddStaticContent />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_STATIC_CONTENTS" />}</>,
    },
    {
      path: "/static-page-management/edit",
      element: (
        <AuthorizationRoute>
          <EditStaticContent />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_STATIC_CONTENTS" />}</>,
    },
    {
      path: "/static-page-management/view",
      element: (
        <AuthorizationRoute>
          <StaticContentView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_STATIC_CONTENTS" />}</>,
    },
    {
      path: "/static-page-management/partner-inquiries",
      element: (
        <AuthorizationRoute>
          <PartnerInquiryList />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="PARTNER_INQUIRIES" />}</>,
    },
    {
      path: "/static-page-management/partner-inquiries/view/:id",
      element: (
        <AuthorizationRoute>
          <PartnerInquiryView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="VIEW_PARTNER_INQUIRY" />}</>,
    },
    {
      path: "/blog-management",
      element: (
        <AuthorizationRoute>
          <BlogManagement />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_BLOG_MANAGEMENT" />}</>,
    },
    {
      path: "/blog-management/add",
      element: (
        <AuthorizationRoute>
          <BlogAdd />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_BLOG_MANAGEMENT" />}</>,
    },
    {
      path: "/blog-management/edit",
      element: (
        <AuthorizationRoute>
          <BlogEdit />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_BLOG_MANAGEMENT" />}</>,
    },
    {
      path: "/blog-management/view",
      element: (
        <AuthorizationRoute>
          <BlogView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_BLOG_MANAGEMENT" />}</>,
    },
    // Video Management Routes
    {
      path: "/video-management",
      element: (
        <AuthorizationRoute>
          <VideoManagement />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_VIDEO_MANAGEMENT" />}</>,
    },
    {
      path: "/video-management/add",
      element: (
        <AuthorizationRoute>
          <AddVideo />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_VIDEO_MANAGEMENT" />}</>,
    },
    {
      path: "/video-management/edit",
      element: (
        <AuthorizationRoute>
          <VideoEdit />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_VIDEO_MANAGEMENT" />}</>,
    },
    {
      path: "/video-management/view",
      element: (
        <AuthorizationRoute>
          <VideoView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_VIDEO_MANAGEMENT" />}</>,
    },
    {
      path: "/country_manager",
      element: (
        <AuthorizationRoute>
          <CountryManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="COUNTRY_MANAGER" />}</>,
    },
    {
      path: "/state_manager",
      element: (
        <AuthorizationRoute>
          <StateManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="STATE_MANAGER" />}</>,
    },
    {
      path: "/city_manager",
      element: (
        <AuthorizationRoute>
          <CityManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="CITY_MANAGER" />}</>,
    },
    {
      path: "/category-subcategory-manager",
      element: (
        <AuthorizationRoute>
          <CategoryManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="CATEGORY_SUBCATEGORY_MANAGER" />}</>,
    },
    {
      path: "/report/registered_companies",
      element: (
        <AuthorizationRoute>
          <RegisteredCompanies />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="REGISTERED_COMPANIES" />}</>,
    },
    {
      path: "/report/subscription_statistics",
      element: <SubscriptionStatistics />,
      name: <>{<UseChange data="SUBSCRIPTION_STATISTICS" />}</>,
    },
    {
      path: "/support_manager",
      element: (
        <AuthorizationRoute>
          <SupportManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="SUPPORT_MANAGER" />}</>,
    },
    // AUDIT LOGS ROUTE - ADDED HERE
    {
      path: "/audit-logs",
      element: (
        <AuthorizationRoute>
          <AuditLogs />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="AUDIT_LOGS" />}</>,
    },
    {
      path: "/geo-access",
      element: (
        <AuthorizationRoute>
          <GeoAccess />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="GEO_ACCESS" />}</>,
    },
    {
      path: "/notification_manager",
      element: (
        <AuthorizationRoute>
          <NotificationManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NOTIFICATION_MANAGER" />}</>,
    },

    {
      path: "/notification_manager/add",
      element: (
        <AuthorizationRoute>
          <AddNotification />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NOTIFICATION_MANAGER" />}</>,
    },
    {
      path: "/notification_manager/edit",
      element: (
        <AuthorizationRoute>
          <EditNotification />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NOTIFICATION_MANAGER" />}</>,
    },
    {
      path: "/subscription_manager",
      element: (
        <AuthorizationRoute>
          <SubscriptionManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="SUBSCRIPTION_MANAGER" />}</>,
    },
    {
      path: "/banner-management",
      element: (
        <AuthorizationRoute>
          <BannerManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="BANNER_MANAGER" />}</>,
    },
    {
      path: "/banner_manager/add",
      element: (
        <AuthorizationRoute>
          <BannerAdd />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="BANNER_MANAGER" />}</>,
    },
    {
      path: "/banner_manager/edit",
      element: (
        <AuthorizationRoute>
          <BannerEdit />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="BANNER_MANAGER" />}</>,
    },
    {
      path: "/subCategories",
      element: (
        <AuthorizationRoute>
          <Subcategory />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="TRANSACTIONS" />}</>,
    },
    {
      path: "/earning-managers",
      element: (
        <AuthorizationRoute>
          <EarningManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_REPORTS" />}</>,
    },
    {
      path: "/company-manager",
      element: (
        <AuthorizationRoute>
          <CompanyManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="COMPANY_MANAGER" />}</>,
    },
    {
      path: "/company-manager/edit",
      element: (
        <AuthorizationRoute>
          <EditCompanyManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="COMPANY_MANAGER" />}</>,
    },
    {
      path: "/forms-manager",
      element: (
        <AuthorizationRoute>
          <FormsManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FORMS_MANAGER" />}</>,
    },
    {
      path: "/forms-manager/view",
      element: (
        <AuthorizationRoute>
          <HiringView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FORMS_MANAGER" />}</>,
    },
    {
      path: "/forms-manager/view",
      element: (
        <AuthorizationRoute>
          <OnboardingView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FORMS_MANAGER" />}</>,
    },
    {
      path: "/jobs-manager",
      element: (
        <AuthorizationRoute>
          <JobsManager />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="JOBS_MANAGER" />}</>,
    },
    {
      path: "/jobs-manager/view",
      element: (
        <AuthorizationRoute>
          <HiringView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FORMS_MANAGER" />}</>,
    },
    {
      path: "/jobs-manager/view",
      element: (
        <AuthorizationRoute>
          <OnboardingView />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FORMS_MANAGER" />}</>,
    },
    {
      path: "/company_onboarding",
      element: (
        <AuthorizationRoute>
          <CompanyOnboarding />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="NAV_EARNING_MANAGER" />}</>,
    },
    {
      path: "/faqs",
      element: (
        <AuthorizationRoute>
          <FAQ />
        </AuthorizationRoute>
      ),
      name: <>{<UseChange data="FAQS" />}</>,
    },
    {
      path: "/profile",
      element: <ProfileTabs />,

      name: <>{<UseChange data="NAV_EARNING_MANAGER" />}</>,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
      name: <>{<UseChange data="NAV_EARNING_MANAGER" />}</>,
    },
    {
      path: "/notification-list",
      element: <BellNotifications />,
      name: <>{<UseChange data="O_NOTIFICATION" />}</>,
    },
    {
      path: "/settings",
      element: <Settings />,
      name: <>{<UseChange data="SETTINGS" />}</>,
    },
    {
      path: "/background-check-pricing",
      element: <BackgroundCheckPricing />,
      name: <>{<UseChange data="BACKGROUND_CHECK_PRICING" />}</>,
    },
    {
      path: "/payroll-onboardings",
      element: <PayrollAdminDashboard />,
      name: <>{<UseChange data="PAYROLL_ONBOARDING" />}</>,
    },
    {
      path: "*",
      element: <HomeRedirect to="/dashboard" />,
    },
  ],
};

export default AdminRoutes;
